import { render, staticRenderFns } from "./buttonImprimir.vue?vue&type=template&id=c85c7e7c&scoped=true&"
import script from "./buttonImprimir.vue?vue&type=script&lang=js&"
export * from "./buttonImprimir.vue?vue&type=script&lang=js&"
import style0 from "./buttonImprimir.vue?vue&type=style&index=0&id=c85c7e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85c7e7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
